import rehypeRaw from 'rehype-raw';

import { Markdown, MarkdownProps } from '~/components/markdown';

// Used on pages where content has html embedded in markdown. Currently only used on the legal pages.
export function MarkdownWithHtml(props: MarkdownProps) {
  return <Markdown {...props} rehypePlugins={[rehypeRaw]} />;
}
